<template>
    <v-tooltip v-if="item.disqualified_count !==null"
               top
               :color="dialogColor"
               max-width="500"
               open-delay="100">
        <template v-slot:activator="{ on }">

            <!--TOOLTIP CONTENTS -->
            <v-card
                class="d-flex align-self-center ml-1 pa-1 justify-center cursor-help"
                v-on="on"
                :color="feasibilityRunning ? 'grey' : componentColor"
                style="margin-bottom: auto; margin-top: auto;"
                min-width="50"
                max-width="50"
                height="36">

                <div v-if="!feasibilityRunning"
                     class="body-1 align-self-center">
                    {{ item.disqualified_count }}
                </div>

                <!-- LOADER -->
                <v-progress-circular v-if="feasibilityRunning"
                                     class="body-1 align-self-center"
                                     color="white"
                                     width="2"
                                     size="20"
                                     indeterminate
                ></v-progress-circular>

            </v-card>

        </template>

        <div v-if="item.disqualified_count > 0">
            <v-alert :color="dialogColor" prominent class="body-2 ma-0" icon="mdi-alert">
                Total of {{ item.disqualified_count }} panelists ({{ disqualifiedPercent }}%) has been terminated
                to this quota cell on start.
                If this number is high it means you are attempting to complete
                this project too fast or this quota cell is requiring
                too many invitation due to low response rate.
            </v-alert>


        </div>
        <div v-else>
            <v-alert :color="dialogColor" prominent class="body-2 ma-0" icon="mdi-information">
                This number indicates # of panelists that have been quota terminated before even getting into a survey.
                Keep an eye out for this number. If you see large number of quota terminations
                you might be sampling too fast or this quota cell is requiring too many invitations due to low response rate.
            </v-alert>
        </div>

    </v-tooltip>
</template>

<script>

import Json from 'vue-json-pretty';
import {feasibilityColorMixin} from "../../../../components/mixins/feasilityColorMixin";

export default {

    mixins: [feasibilityColorMixin],

    components: {
        Json
    },

    props: {
        item: {
            type: Object,
            required: true,
        },

        targetCompletes: {
            type: Number,
            required: true,
        },

        feasibilityRunning: {
            type: Boolean,
            required: true,
            default: false,
        },

        showAnalyzeResults: {
            type: Boolean,
            required: true,
            default: false,
        }
    },

    computed: {

        componentColor() {

            if (this.item.disqualified_count === 0) return 'grey darken-1';

            const percent = this.item.disqualified_count / this.item.quota * 100;

            if (percent < 5) {
                return 'green darken-2';
            }
            if (percent < 10) return 'yellow darken-2';
            if (percent < 20) return 'orange darken-2';

            return 'red darken-2';
        },

        dialogColor() {
            return this.componentColor !== 'grey darken-1' ? this.componentColor : 'primary';
        },

        disqualifiedPercent() {
            return Math.round(this.item.disqualified_count / this.item.quota * 100 * 100) / 100;
        },
    }
}
</script>
